import { createFileRoute } from '@tanstack/react-router'
import { TimeToHirePage } from '@/features/candidates/components/time-to-hire-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/time-to-hire',
)({
  component: TimeToHirePage,
  beforeLoad: () => ({
    title: 'Time to Hire',
    headerTitleKey: 'header.timeToHire.title',
    headerDescriptionKey: 'header.timeToHire.description',
  }),
})
